import React from "react";
import { Card, CardContainer } from "../../../../components/Card";
import { BarChart, LineChart } from "../../../../components/Charts";

const Marketing = ({ data }) => {
    return (
        <>
            <CardContainer>
                <LineChart
                    data={data}
                    series={[
                        {
                            name: "Total App Downloads",
                            key: "total_app_downloads",
                        },
                    ]}
                    xKey="week"
                    // yLabel="Seats Sold"
                    title="Total App Downloads"
                />
            </CardContainer>
            <CardContainer>
                <LineChart
                    data={data}
                    series={[
                        {
                            name: "The Daily Adoption",
                            key: "the_daily_adoption_entered",
                        },
                    ]}
                    xKey="week"
                    // yLabel="Seats Sold"
                    title="The Daily Adoption"
                />
                <LineChart
                    data={data}
                    series={[
                        {
                            name: "Creater Pro",
                            key: "creator_pro_verified",
                        },
                    ]}
                    xKey="week"
                    // yLabel="Seats Sold"
                    title="Creator Pro"
                />
            </CardContainer>
            <CardContainer>
                <LineChart
                    data={data}
                    series={[
                        {
                            name: "Downloads CAC",
                            key: "app_download_cac_fb_meta_wa_email",
                        },
                        {
                            name: "Sign up CAC",
                            key: "sign_up_cac",
                        },
                    ]}
                    xKey="week"
                    // yLabel="Seats Sold"
                    title="App Downloads (CAC)"
                />
                <LineChart
                    data={data}
                    series={[
                        {
                            name: "Sign Ups",
                            key: "sign_ups",
                        },
                    ]}
                    xKey="week"
                    // yLabel="Seats Sold"
                    title="Sign Up Stats"
                />
            </CardContainer>
            <CardContainer>
                <BarChart
                    data={data}
                    series={[
                        {
                            name: "Community Growth",
                            key: "community_growth",
                        },
                        {
                            name: "Community Engagement",
                            key: "community_engagement",
                        },
                    ]}
                    xKey="week"
                    title="Community Engagements vs Growth Stats"
                    yOverlap={[
                        {
                            name: "Community Growth",
                        },
                        {
                            name: "Community Engagement",
                            opposite: true,
                        },
                    ]}
                />
            </CardContainer>
        </>
    );
};

export default Marketing;
